import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { PublicSubscriptionContextOperationsResponse } from './public-subscription-context-operations.response';
import { PublicPaymentMethodResponse } from './public-payment-method.response';
import { PublicSubscriptionBillingAddressResponse } from './public-subscription-billing-address.response';
import { PublicSubscriptionDetailsShippingAddressResponse } from './public-subscription-details-shipping-address.response';
import { SubscriptionStatus } from '../../../shared/enums';
import { SubscriptionNumber } from '../../../shared/types';
import { ShippingMethodDictionaryResponse } from '../../../shared/api/responses';
import { PublicSubscriptionItemResponse } from './public-subscription-item.response';

@jsonObject
export class PublicSubscriptionDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Boolean)
  public readonly isLocked!: boolean;

  @jsonMember(String)
  public readonly number!: SubscriptionNumber;

  @jsonMember(Number)
  public readonly cardChargeDay!: number;

  @jsonMember(String)
  public readonly status!: SubscriptionStatus;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonMember(Number)
  public readonly itemsPrice!: number;

  @jsonMember(Number)
  public readonly shippingPrice!: number;

  @jsonMember(Date)
  public readonly lastPaymentDate!: Date;

  @jsonMember(Date)
  public readonly nextPaymentDate?: Nillable<Date>;

  @jsonMember(Date)
  public readonly cancelledDate?: Nillable<Date>;

  @jsonMember(PublicPaymentMethodResponse)
  public readonly paymentMethod!: PublicPaymentMethodResponse;

  @jsonMember(ShippingMethodDictionaryResponse)
  public readonly shippingMethod!: ShippingMethodDictionaryResponse;

  @jsonMember(PublicSubscriptionBillingAddressResponse)
  public readonly billingAddress!: PublicSubscriptionBillingAddressResponse;

  @jsonArrayMember(PublicSubscriptionItemResponse)
  public readonly items!: PublicSubscriptionItemResponse[];

  @jsonMember(PublicSubscriptionDetailsShippingAddressResponse)
  public readonly shippingAddress!: PublicSubscriptionDetailsShippingAddressResponse;

  @jsonMember(PublicSubscriptionContextOperationsResponse)
  public readonly contextOperations!: PublicSubscriptionContextOperationsResponse;
}
